import React from "react";
import Icon from "../Icon";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const FilterCapsule = ({data, img=true, active = false, ...props }) => {
  return (
    <div {...props}>
      <p className={`filter-capsule d-flex p-3 m-2 ${ active && "bg-saffron text-light"}`}>
        {img && <img src={data.icon} alt="" className={ active && "bg-white p-1 rounded-circle"} />}
        <span className="font-16 ">{data?.name}</span>
      </p>
    </div>
  );
};

export default FilterCapsule;
